import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuServiceService } from '../../menu-service/menu-service.service';
import { Utils } from 'src/app/core/resources/utils';
import { Router } from '@angular/router';
import { Fmt } from 'src/app/core/messages/fmt';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { ServiceResources } from '../../resources/services';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

//TODO: Documentar el codigo
@Component({
  selector: 'app-observations-service-form',
  templateUrl: './observations-service-form.component.html',
  styleUrls: ['./observations-service-form.component.scss']
})
export class ObservationsServiceFormComponent implements OnInit, OnDestroy {
  permission = Permission;
  formSubscription: Subscription;
  observations = new FormControl('');
  observationsToDriver = new FormControl('');
  isDialog: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public paramsDialog: { cargo: Cargo },
    public dialogRef: MatDialogRef<ObservationsServiceFormComponent>,
    public menuService: MenuServiceService,
    private router: Router,
    private snackBarService: SnackBarService,
    private permissionRole: PermissionRole,
    private serviceResources: ServiceResources
  ) { }

  async ngOnInit() {
    await this.checkDialogParams();
    this.setLocalValues();
    this.setSubscription();
    this.checkPermissionsToEdit();
  }

  private async checkDialogParams() {
    if (this.paramsDialog && this.paramsDialog.cargo) {
      this.isDialog = true;
      this.menuService.cargo = this.paramsDialog.cargo;
      this.menuService.patchForm(this.paramsDialog.cargo, false);
      await this.menuService.setCargoConsignments();
      await this.menuService.setCargoVehicle();
    }
  }

  private setLocalValues() {
    this.observations.setValue(this.menuService.form.get('observation').value);
    this.observationsToDriver.setValue(this.menuService.form.get('observationDriver').value);
  }

  private setSubscription() {
    this.formSubscription = this.menuService.formObservable.subscribe(() => this.setLocalValues());
  }

  private checkPermissionsToEdit() {
    if (!this.canEditObservations) {
      this.observations.disable();
      this.observationsToDriver.disable();
    }
  }

  get canEditObservations(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.addObservation
    );
  }

  /**
   * @description Navigates to the previous step
   */
  backToPreviousStep() {
    this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.additionalValuesService, this.menuService.cargo.consecutive)]);
  }

  /**
   * @description Saves form data and continues if valid
   */
  saveAndContinue() {
    this.menuService.form.get('observation').setValue(this.observations.value);
    this.menuService.form.get('observationDriver').setValue(this.observationsToDriver.value);
    this.menuService.updateService().then(() => {
      this.snackBarService.openSnackBar("Servicio actualizado exitosamente");
      if (!this.isDialog) this.continueToNextStep();
      else this.dialogRef.close({ state: true });
    }).catch(() => this.snackBarService.openSnackBar('Ocurrió un error al actualizar el servicio', undefined, 'error'));
  }

  continueToNextStep() {
    const isRequiredConsignmentsService = this.menuService.isRequiredConsignmentsService();
    this.router.navigate([Fmt.string(isRequiredConsignmentsService
      ? this.serviceResources.serviceRequestUrls.consignmentsService
      : this.serviceResources.serviceRequestUrls.servicePublication
      , this.menuService.cargo.consecutive)]);
  }

  ngOnDestroy() {
    if (this.formSubscription) this.formSubscription.unsubscribe();
  }
}
